module.exports = __webpack_public_path__ + "img/UF_logo.dbc91aa7.jpg";